<template>
    <div class="container-new order-right-summary right-info-block" style="text-align: left;">
        <div class="order-instruction-header">
            <i class="ion-information-circled header-icon"></i>
            <h2>Pomoc</h2>
        </div>
        <img class="right-order-block-img" src="https://www.mojadostawa.pl/lib/customerZone/images/ind-main-02.jpg" alt="" />
        <div class="simple-paragraph">
            <p>Jeżeli chciałbyś dokonać ewentualnej zmiany w swoim zamówieniu lub chciałbyś uzyskać więcej informacji o realizowanym zleceniu, skontaktuj sie z nami.</p>
            <p>Nasi konsultanci są do Twojej stałej dyspozycji pod nr tel.: <span class="color-blue">(22) 307 68 98</span>.</p>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'helpBox',
        props: ["step"],
        data () {
            return {

            }
        }
    }
</script>




// WEBPACK FOOTER //
// HelpBox.vue?b0ceecfe